const env = require('./env')

switch (env.route) {
    case 'index':
        require('./routes/index')
        break

    case 'beta':
    case 'token':
    case 'jumo/token':
        require('./routes/token')
        break

    case 'reset':
    case 'password/reset':
        require('./routes/passwordReset')
        break

    default:
        break
}




/** WEBPACK FOOTER **
 ** ./js/credentials/creds.js
 **/